module.exports = __webpack_public_path__ + "img/chess_japanchess02.5f2358c1.png";